<template lang="pug">
form(@submit.prevent='submit')
  .columns.align-center
    .column.col-auto(v-if='isEnabledFilter("referencia_gteq")')
      .pb-1
        small {{ filters.referencia_gteq }}
        datepicker(
          v-model='q.referencia_gteq',
          placeholder='Mês início',
          input-class='form-input input-sm'
          type="month"
          format="MM/YYYY"
        )
    .column.col-auto(v-if='isEnabledFilter("referencia_lteq")')
      .pb-1
        small {{ filters.referencia_lteq }}
        datepicker(
          v-model='q.referencia_lteq',
          placeholder='Mês final',
          input-class='form-input input-sm'
          type="month"
          format="MM/YYYY"
        )
    .column.col-auto.mt-2.pt-2.no-print
      button.mt-2.btn.btn-action.s-circle.btn-sm(type='submit')
        i.fa.fa-filter
      a.mt-2.ml-2.btn.btn-action.s-circle.btn-sm.no-print(
        onclick='window.print()'
      )
        i.fa.fa-print
    .column.col-auto.mt-2.pt-2.no-print
      enabled-filters.mt-1(
        :localStorageKey='filterKey',
        :defaultEnabledFilters='defaultEnabledFilters',
        :enabledFilters='enabledFilters',
        :filters='filters',
        :query='q',
        :setEnabledFilters='setEnabledFilters'
      )
</template>

<script>
import filterMixin from '@/mixins/filter'

export default {
  mixins: [filterMixin],
  props: {
    filterKey: { type: String, default: 'osm-filters' },
  },
  data() {
    return {
      filters: {
        referencia_gteq: 'Mês início',
        referencia_lteq: 'Mês final',
      },
      q: {
        referencia_gteq: null,
        referencia_lteq: null,
      },
      defaultEnabledFilters: ['referencia_gteq', 'referencia_lteq'],
    }
  },
  created() {
    const today = new Date()
    const referencia_gteq = new Date(today.getFullYear(), today.getMonth(), 1)
    referencia_gteq.setFullYear(referencia_gteq.getFullYear() - 1)
    this.q.referencia_gteq = referencia_gteq
    this.q.referencia_lteq = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0,
    )
    this.submit()
  },
  methods: {
    submit() {
      this.$emit('submit', {
        ...this.q,
        referencia_gteq: this.$options.filters.date(
          this.q.referencia_gteq,
          'YYYY-MM',
          null,
        ),
        referencia_lteq: this.$options.filters.date(
          this.q.referencia_lteq,
          'YYYY-MM',
          null,
        ),
      })
    },
  },
}
</script>
